export default function SettingsButton({ onClick, style }) {
  return (
    <button
      className="panel settings-btn"
      onClick={onClick}
      title="Wheel settings"
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        outline: "none",
        padding: 0,
        marginRight: 8,
        ...style,
      }}
    >
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <line x1="7" y1="10" x2="25" y2="10" stroke="#888" strokeWidth="2.2" strokeLinecap="round" />
        <line x1="7" y1="16" x2="25" y2="16" stroke="#888" strokeWidth="2.2" strokeLinecap="round" />
        <line x1="7" y1="22" x2="25" y2="22" stroke="#888" strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="12" cy="10" r="3" fill="#888" />
        <circle cx="20" cy="16" r="3" fill="#888" />
        <circle cx="15" cy="22" r="3" fill="#888" />
      </svg>
    </button>
  );
}
